export function resolveImmutableForkPredecessor(
  predecessor: { id: string; status?: string; currentVersion?: string },
): { predecessorStrategyId: string; predecessorVersion: string } {
  const predecessorStrategyId = predecessor.id?.trim();
  const predecessorVersion = predecessor.currentVersion?.trim();
  if (!predecessorStrategyId || !predecessorVersion) {
    throw new Error('IMMUTABLE_PREDECESSOR_REQUIRED: bake the predecessor strategy before creating a fork.');
  }
  if (predecessor.status !== 'baked' && predecessor.status !== 'published') {
    throw new Error('IMMUTABLE_PREDECESSOR_REQUIRED: fork source must be baked or published.');
  }
  return { predecessorStrategyId, predecessorVersion };
}

export function normalizeImmutableForkHypothesis(value: string): string {
  const hypothesis = value?.trim();
  if (!hypothesis) {
    throw new Error('FORK_HYPOTHESIS_REQUIRED: describe the falsifiable change before creating a fork.');
  }
  return hypothesis;
}
